export default "__VITE_ASSET__nUCMPX2N__"